import filter from 'lodash/filter'
import find from 'lodash/find'

export const getFilteredPropOrProjectImages = <
  T extends { isFloorplan: boolean; position: number; isFromProject?: boolean }
>(
  images: T[]
) => {
  const filteredImages = filter(images, (image) => !image.isFloorplan)
  const sortedImages = filteredImages.sort((a, b) => {
    if (a.isFromProject && !b.isFromProject) {
      return 1 // a is larger if a is from project but b is not
    }
    if (!a.isFromProject && b.isFromProject) {
      return -1 // a is smaller if a is not from project but b is
    }
    // if both are from project or both are not from project, sort by position
    return a.position - b.position
  })

  const floorPlan = find(images, (image) => image.isFloorplan)
  return { filteredImages: sortedImages, floorPlan }
}
